import { lazy } from 'react';
import i18next from 'i18next';

const ProfileEdit = lazy(() => import('../../../../../pages/profile-edit'));
const PasswordChange = lazy(() => import('../../../../../pages/change-password'));

const PROFILE_ROUTE_EDIT = {
  path: '/profile/edit',
  exact: true,
  additional: {
    component: ProfileEdit,
    protected: true,
    title: i18next.t('titles:editProfile'),
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.editProfile || 'Edit profile',
    },
  },
};

const PROFILE_ROUTE_CHANGE_PASSWORD = {
  path: '/change-password',
  exact: true,
  additional: {
    component: PasswordChange,
    protected: true,
    title: i18next.t('titles:changePassword'),
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.changePassword || 'Change password',
    },
  },
};

export const PROFILE_ROUTES = {
  // ------- For current accounts ------
  edit: PROFILE_ROUTE_EDIT,
  changePassword: PROFILE_ROUTE_CHANGE_PASSWORD,
};

